import React, { useState, useEffect, useRef } from 'react';
import useGroupsStore from '../../stores/groupsStore';
import useStudentsStore from '../../stores/studentsStore';
import useSubjectStore from '../../stores/subjectStore';

function AdminScheduleModal({ open, onClose, onSave, initialData, slotTime, onDelete, groupId: propGroupId, studentId: propStudentId, freeTime = false }) {
  const { groups, fetchGroups } = useGroupsStore();
  const { students, fetchStudents } = useStudentsStore();
  const { subjects, fetchSubjects } = useSubjectStore();
  const [groupId, setGroupId] = useState(
    initialData?.groupId || initialData?.group?._id || propGroupId || ''
  );
  const [studentId, setStudentId] = useState(
    initialData?.studentId || initialData?.student?._id || propStudentId || ''
  );
  const [subjectId, setSubjectId] = useState(initialData?.subject?._id || initialData?.subject || '');
  const [comment, setComment] = useState(initialData?.comment || '');
  const [error, setError] = useState('');
  // const [room, setRoom] = useState(initialData?.room || '');
  const [assignMode, setAssignMode] = useState('group'); // 'group' | 'students'
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [studentsDdOpen, setStudentsDdOpen] = useState(false);
  const [studentsSearch, setStudentsSearch] = useState('');
  const studentsDdRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (studentsDdRef.current && !studentsDdRef.current.contains(e.target)) {
        setStudentsDdOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const [duration, setDuration] = useState(
    initialData && initialData.endTime && initialData.startTime &&
    (parseInt(initialData.endTime) - parseInt(initialData.startTime) === 2) ? 2 : 1
  );
  const [startTimeCustom, setStartTimeCustom] = useState(initialData?.startTime || '');
  const [endTimeCustom, setEndTimeCustom] = useState(initialData?.endTime || '');

  // UI styles
  const inputStyle = {
    width: '100%',
    padding: 12,
    border: '1px solid #E0E0E6',
    borderRadius: 10,
    background: '#fff',
    fontSize: 14,
    marginTop: 4,
    outline: 'none'
  };
  const triggerStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #E0E0E6',
    borderRadius: 10,
    background: '#fff',
    textAlign: 'left'
  };

  useEffect(() => {
    fetchGroups();
    fetchStudents();
    fetchSubjects();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (propGroupId) setGroupId(propGroupId);
    else if (initialData?.groupId) setGroupId(initialData.groupId);
    else if (initialData?.group?._id) setGroupId(initialData.group._id);
  }, [propGroupId, initialData]);
  useEffect(() => {
    if (propStudentId) setStudentId(propStudentId);
    else if (initialData?.studentId) setStudentId(initialData.studentId);
    else if (initialData?.student?._id) setStudentId(initialData.student._id);
  }, [propStudentId, initialData]);

  useEffect(() => {
    setSubjectId(initialData?.subject?._id || initialData?.subject || '');
    setComment(initialData?.comment || '');
    if (initialData?.startTime) setStartTimeCustom(initialData.startTime);
    if (initialData?.endTime) setEndTimeCustom(initialData.endTime);
    // setRoom(initialData?.room || '');
  }, [initialData]);

  const selectedGroup = groups.find(g => String(g._id) === String(groupId));
  const groupStudents = students.filter(s => (Array.isArray(s.groups) ? s.groups : [s.group]).some(g => String(g?._id || g) === String(groupId)));

  if (!open) return null;

  const handleSave = async () => {
    if (!subjectId) {
      setError('Пожалуйста, выберите предмет');
      return;
    }
    setError('');
    // Расширенная логика сохранения
    // 1) Индивидуальная страница (propStudentId): можно добавить ещё учеников — создадим слоты каждому
    if (propStudentId) {
      const baseStudents = selectedStudents.length ? selectedStudents : (studentId ? [studentId] : [propStudentId]);
      for (const sid of baseStudents) {
        await onSave({ groupId, studentId: sid, subjectId, comment, slotTime, duration, customStartTime: startTimeCustom, customEndTime: endTimeCustom });
      }
      // reset local state
      setSelectedStudents([]);
      setStudentId('');
      setAssignMode('group');
      return;
    }
    // 2) Групповая страница: либо вся группа, либо выбранные ученики (могут быть из любых групп)
    if (assignMode === 'students' && selectedStudents.length) {
      await onSave({ groupId: '', studentId: '', subjectId, comment, slotTime, duration, students: selectedStudents, customStartTime: startTimeCustom, customEndTime: endTimeCustom });
      setSelectedStudents([]);
      setAssignMode('group');
      return;
    }
    await onSave({ groupId, studentId, subjectId, comment, slotTime, duration, customStartTime: startTimeCustom, customEndTime: endTimeCustom });
    setSelectedStudents([]);
    setStudentId('');
    if (!propGroupId) setGroupId('');
    setAssignMode('group');
  };

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="modal-content" style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 320, maxWidth: 400 }}>
        <h3 style={{ marginBottom: 20 }}>{initialData && Object.keys(initialData).length > 0 ? 'Редактировать занятие' : 'Добавить занятие'}</h3>
        {/* Переключатель режима */}
        {!propStudentId && (
          <div className="assign-switch" style={{ marginBottom: 12 }}>
            <button type="button" className={`assign-switch-btn ${assignMode==='group' ? 'is-active' : ''}`} onClick={() => setAssignMode('group')}>Вся группа</button>
            <button type="button" className={`assign-switch-btn ${assignMode==='students' ? 'is-active' : ''}`} onClick={() => setAssignMode('students')}>Выбрать учеников</button>
          </div>
        )}

        {/* Блок выбора группы — на индивидуальной странице (propStudentId) НЕ показываем */}
        {(assignMode === 'group' || !!propGroupId) && !propStudentId && (
          <div className="modal-field" style={{ marginBottom: 16 }}>
            <label>Группа:</label>
            <select value={groupId} onChange={e => { setGroupId(e.target.value); setStudentId(''); }} style={inputStyle} disabled={!!propGroupId}>
              <option value=''>Выберите группу</option>
              {groups.map(g => <option value={g._id} key={g._id}>{g.name}</option>)}
            </select>
          </div>
        )}

        {assignMode === 'group' ? null : (
          <div style={{ marginBottom: 16 }}>
            <label>Ученики:</label>
            <div ref={studentsDdRef} style={{ position: 'relative', marginTop: 4 }}>
              <button type="button" onClick={() => setStudentsDdOpen(v=>!v)} className={`modal-multiselect-trigger ${studentsDdOpen ? 'modal-multiselect-trigger--open' : ''}`} style={triggerStyle}>
                {selectedStudents.length ? `Выбрано: ${selectedStudents.length}` : 'Выбрать учеников'}
              </button>
              {studentsDdOpen && (
                <div className="modal-multiselect-dd">
                  <input placeholder="Поиск" value={studentsSearch} onChange={e => setStudentsSearch(e.target.value)} className="modal-multiselect-search" style={{ ...inputStyle, marginTop: 0 }} />
                  {students
                    .filter(s => s.fullName?.toLowerCase().includes(studentsSearch.trim().toLowerCase()))
                    .map(s => {
                      const checked = selectedStudents.includes(s._id);
                      return (
                        <label key={s._id} className="modal-multiselect-item">
                          <input type="checkbox" checked={checked} onChange={(e) => {
                            setSelectedStudents(prev => e.target.checked ? [...new Set([...prev, s._id])] : prev.filter(id => id !== s._id));
                          }} />
                          <span>{s.fullName}</span>
                          {s.group && <span style={{ color: '#999', fontSize: 12, marginLeft: 'auto' }}>{typeof s.group === 'object' ? s.group.name : ''}</span>}
                        </label>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <label>Предмет:</label>
          <select value={subjectId} onChange={e => setSubjectId(e.target.value)} style={{ ...inputStyle, borderColor: error ? '#e74c3c' : '#E0E0E6' }}>
            <option value=''>Выберите предмет</option>
            {subjects.map(s => <option value={s._id} key={s._id}>{s.name}</option>)}
          </select>
          {error && <div style={{ color: '#e74c3c', fontSize: 13, marginTop: 4 }}>{error}</div>}
        </div>
        {freeTime ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
            <div>
              <label>Начало:</label>
              <input type="time" value={startTimeCustom} onChange={e => setStartTimeCustom(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label>Окончание:</label>
              <input type="time" value={endTimeCustom} onChange={e => setEndTimeCustom(e.target.value)} style={inputStyle} />
            </div>
          </div>
        ) : (
          <div style={{ marginBottom: 16 }}>
            <label>Длительность занятия:</label>
            <select value={duration} onChange={e => setDuration(Number(e.target.value))} style={inputStyle}>
              <option value={1}>1 час</option>
              <option value={2}>2 часа</option>
            </select>
          </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <label>Комментарий:</label>
          <textarea value={comment} onChange={e => setComment(e.target.value)} style={{ ...inputStyle, minHeight: 80 }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 16 }}>
          <button onClick={onClose} style={{ padding: '10px 16px', borderRadius: 10, border: '1px solid #E0E0E6', background: '#fff' }}>Отмена</button>
          {initialData && Object.keys(initialData).length > 0 && onDelete && (initialData.studentId || studentId) && (
            <button onClick={onDelete} style={{ padding: '10px 16px', borderRadius: 10, background: '#e74c3c', color: '#fff', border: 'none' }}>Удалить</button>
          )}
          {initialData && Object.keys(initialData).length > 0 && onDelete && !!propStudentId && !initialData.studentId && !studentId && (
            <button onClick={() => onDelete('onlyThisUser')} style={{ padding: '10px 16px', borderRadius: 10, background: '#e67e22', color: '#fff', border: 'none' }}>Удалить только для этого пользователя</button>
          )}
          <button onClick={handleSave} style={{ padding: '10px 16px', borderRadius: 10, background: '#6c3be4', color: '#fff', border: 'none' }}>Сохранить</button>
        </div>
      </div>
    </div>
  );
}

export default AdminScheduleModal; 